import React from 'react';
import { useAppContext } from '../../../Services/AppContext';
import { Message } from '../../../graphql/graphql';
import moment from 'moment-timezone';

export default function useNotificationTemplate(message: Message) {
	const { dateFormatMoment } = useAppContext();

	const templateFunctions: Record<string, (value: string) => string> = {
		shortDate: value => moment(value).format(dateFormatMoment),
		shortTime: value => moment(value).format('HH:mm'),
		dateTime: value => moment(value).format(dateFormatMoment + ' HH:mm'),
	};

	const formatValue = (value: string, format: string) =>
		templateFunctions[format]?.(value) ?? value;

	const formattedMessage = () => {
		let { text, template, templateData } = message?.content;

		if (!template) {
			return text;
		}

		const pattern = /%[a-z]*(:[a-z]*)?%/gim;
		const matches = template.match(pattern);
		if (!matches) {
			return text;
		}

		for (const match of matches) {
			const [key, format] = match.replace(/%|\$/g, '').split(':');
			const value = templateData[key];
			const formattedValue = format ? formatValue(value, format) : value;
			template = template.replace(match, formattedValue ? formattedValue : '');
		}

		return template;
	};

	return {
		formattedMessage,
	};
}
